module.exports = __webpack_public_path__ + "static/media/empty-score-assessment.032df59f.svg";